export default __webpack_public_path__ + "static/media/signUp.e582ae54.png";